document.addEventListener('DOMContentLoaded', () => {
    const storeLocator = document.querySelector('.store-locator-section');
    if (!storeLocator) return;

    const tabs = storeLocator.querySelectorAll('.city-tab');
    const cityContents = storeLocator.querySelectorAll('.city-stores');

    function switchCity(cityHandle, clickedTab) {
        const tabIcons = storeLocator.querySelectorAll('.tab-icon');
        const tabsContainer = document.getElementById('city-tabs');

        tabIcons.forEach(icon => {
            icon.classList.add('hidden');
            icon.classList.remove('block');
        });

        tabs.forEach((tab) => {
            if (tab.dataset.city === cityHandle) {
                tab.classList.remove('opacity-20');

                if (clickedTab && tabsContainer) {
                    clickedTab.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'center'
                    });
                }

                const tabIndex = parseInt(tab.dataset.tabIndex);
                if (tabIndex >= 0) {
                    const iconBeforeThisTab = Array.from(tabIcons).find(icon =>
                        parseInt(icon.dataset.iconFor) === tabIndex - 1
                    );
                    if (iconBeforeThisTab) {
                        iconBeforeThisTab.classList.remove('hidden');
                        iconBeforeThisTab.classList.add('block');
                    }
                }
                return;
            }
            tab.classList.add('opacity-20');
        });

        cityContents.forEach((content) => {
            if (content.dataset.cityContent === cityHandle) {
                content.classList.remove('hidden');
            } else {
                content.classList.add('hidden');
            }
        });
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            const cityHandle = this.dataset.city;
            switchCity(cityHandle, this);
        });
    });

    storeLocator.addEventListener('click', (event) => {
        const gallery = event.target.closest('.store-gallery');
        if (!gallery || !storeLocator.contains(gallery)) return;

        const card = gallery.closest('.store-card');
        const trigger = card?.querySelector('[data-accordion-trigger]');
        trigger?.click();
    });
});
